import { DefaultService } from '@/services/DefaultService';

export default class AssAdiantamentoAcertoService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env);
    }
    
    updateSituacao(uuid) {
        return this._http.get(
            `${this._env}/despesa/acerto-despesa/assatendimento/updatesituacao/${uuid}`, 
            this._headers
            ).then(res => {
                return res.body;
            }, err => {
                this.handleError(err);
            });
    }
    
    findAllByAcertoDespesa(column, order, page, limit, uuiddes_acerto_despesa, params) {
        return this._http.get(
            encodeURI(`${this._env}/despesa/acerto-despesa/assatendimento.json?page=${page}&limit=${limit}&order=${order}&column=${column}&uuiddes_acerto_despesa=${uuiddes_acerto_despesa}&param=${params}`), 
            this._headers
        ).then(res => {
            return res.body;
        }, err => {
            this.handleError(err);
        });
    }
    
    findAllCombo(...params) {
        return this._http.get(
            encodeURI(`${this._env}/despesa/acerto-despesa/assatendimento/getcombo.json?param=${params}`), 
            this._headers
        ).then(res => {
            return res.body;
        }, err => {
            this.handleError(err);
        });
    }

    findNaoAssociados(column, order, page, limit, acertoDespesa, ...params) {
        return this._http.post(
            encodeURI(`${this._env}/despesa/acerto-despesa/assatendimento/naoassociados?page=${page}&limit=${limit}&column=${column}&order=${order}&param=${params}`), 
            acertoDespesa, 
            this._headers 
        ).then(res => {
            return res.body;
        }, err => {
            this.handleError(err);
        });
    }
    
    find(id) {
        return this._http.get(
            `${this._env}/despesa/acerto-despesa/assatendimento/${id}.json`, 
            this._headers
        ).then(res => {
            return res.body;
        }, err => {
            this.handleError(err);
        });
    }

    save(assAcertoDespesaAdiantamentoList) {
        return this._http.post(
            `${this._env}/despesa/acerto-despesa/assatendimento`, 
            assAcertoDespesaAdiantamentoList,
            this._headers
        ).then(res => {
            return res.body;
        }, err => {
            this.handleError(err);
        });
    }

}